import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sales-why-get-protected',
  templateUrl: './why-get-protected.component.html',
  styleUrls: ['./why-get-protected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhyGetProtectedComponent {}
